import loadable from '@loadable/component';

export const PcgSiteWrapper = loadable(
  () => import(/* webpackChunkName: "pcg-site" */ './PcgSiteWrapper'),
);
